import axios from 'axios';
import { BACKEND } from '../../constants/urls';
/**
 * Obtener proveedores
 * @param {*} filter filtro para resultados
 * @param {*} cancelToken token para cancelacion
 */
export async function getProveedores(filter = {}, cancelToken = null) {
  const proveedores = await axios.get(`${BACKEND}/proveedores`, {
    params: filter,
    cancelToken,
  });
  console.log('getProveedores: ', proveedores);
  return proveedores.data ? proveedores.data : null;
  // return axios
  //   .get(`${BACKEND}/proveedores`, {
  //     params: filter,
  //     cancelToken: cancelToken,
  //   })
  //   .then((res) => (res.data ? res.data : null));
}
/**
 * Crear proveedor
 * @param {*} data Datos del proveedor
 * @param {*} cancelToken token para cancelacion
 */
export function postProveedor(data, cancelToken = null) {
  return axios
    .post(`${BACKEND}/proveedores`, data, {
      cancelToken,
    })
    .then((res) => res.data);
}
